import React from 'react';
import Form from 'react-bootstrap/Form';  

const FreeActivation = () => {
  return (
  
      <div className="col-lg-6 m-3">
                  <div className="card border-0 shadow ">
                    <div className="card-header bg bg-info border-0">
                      <h4>Free Activation</h4>
                    </div>

                    <div className="card-body">
                      <div className="col-lg-12">
                        <label for="exampleInputPassword1" class="form-label">
                          User ID
                        </label>
                        <input
                          type="password"
                          class="form-control"
                          placeholder="Enter User ID"
                          id="exampleInputPassword1"
                        />
                      </div>

                      <div className="col-lg-12 mt-3">
                        <label for="exampleInputPassword1" class="form-label">
                          Password
                        </label>
                        <input
                          type="password"
                          class="form-control"
                          placeholder="Enter Password"
                          id="exampleInputPassword1"
                        />
                      </div>
                      <div className="col-lg-12 mt-3">
                        <label for="exampleInputPassword1" class="form-label">
                          PINs
                        </label>
                        <input
                          type="password"
                          class="form-control"
                          placeholder="Enter Password"
                          id="exampleInputPassword1"
                        />
                      </div>
                      {/* <Form className='p-2  '>
      {[ 'radio'].map((type) => (
        <div  className="mb-3">
         <h4> <Form.Check
            inline
            label="/600 Package"
            name="group1"
           
            
          />
          <Form.Check
            inline
            label="/2500 Package"
            name="group1"
          />
          </h4>
        </div>
      ))}
    </Form> */}

                      <div className="col-lg-12 mt-3">
                        <button className="btn btn-primary">Submit</button>
                      </div>
                    </div>
                  </div>
    </div>
  )
}

export default FreeActivation;